import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Navbar, NavbarNav, NavbarToggler, Collapse, NavItem, NavLink } from 'mdbreact';
import UserProfile from "./UserProfile";
// import Search from "./Search";
import "./header.css";
import { API_URL } from "../../config/Config";
import { connect } from "react-redux";
import { setCategories } from "../../redux/actions/categories";
import axios from "axios/index";


class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            isWideEnough: false,
            dropdownnOpen: false,
            menuOpen: false,
            selectedCatItem: {
                id: 1,
                image_url: "uploads/categories/1.jpg",
                name: "زیبایی و سلامتی"
            },
            loading: false,
            catItems: []
        };
        this.onClick = this.onClick.bind(this);
        this.toggle = this.toggle.bind(this);
    }
    async componentDidMount() {
        if (!this.props.categories.isFetching) {
            await this.handleRequest();
        }
        this.setState({ selectedCatItem: this.props.categories.items[1] });
        this.getCurrentLevelCat(0);
    }
    getCurrentLevelCat(i) {
        // const catItems = this.props.categories.items.filter(cat =>parseInt(cat.parent_id) === i).map(cat => cat);
        const catItems = this.props.categories.items.filter(cat => parseInt(cat.parent_id, 10) === i);
        this.setState({ catItems });
    }
    async handleRequest() {
        let response = await axios.get(`${API_URL}category`);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            alert('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.');
        } else {
            let categories = response.data.data;
            this.props.setCategories(categories);
        }
        console.log("done");
        this.setState({ loading: true });
    };
    onClick() {
        this.setState({
            collapse: !this.state.collapse,
        });
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }
    openMenu = event => {
        this.setState({
            menuOpen: !this.state.menuOpen
        });
    };
    closeMenu = event => {
        this.setState({
            menuOpen: false
        });
    };

    showCatInfo(catItem) {
        this.setState({
            selectedCatItem: catItem,
        })
    };

    render() {
        const { isAuthenticated } = this.props;
        const { catItems } = this.state;
        return (
            <Navbar color="m-grid__item m-header rtl " expand="lg" fixed="top" scrolling className={this.props.location.pathname !== '/' ? 'top-nav-collapse' : ''}>
                <div className="container">
                    {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} className={!this.state.collapse ? 'collapsed' : ''}><span /></NavbarToggler>}
                    <div className="page-logo">
                        <Link to="/">
                            <img src="./../../assets/images/logo-green.png" height="150" alt="سامانه ساماندهی مشاغل" />
                        </Link>
                    </div>

                    <Collapse isOpen={this.state.collapse} navbar className="d-flex justify-content-between">
                        <div className="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-dark m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark ">
                            <NavbarNav className="m-menu__nav m-menu__nav--submenu-arrow ">
                                <NavItem active>
                                    <NavLink className="nav-link m-menu__item" to="/" exact>صفحه اصلی</NavLink>
                                </NavItem>
                                <NavItem onMouseOver={this.openMenu.bind(this)} onMouseOut={this.closeMenu.bind(this)}>
                                    <a className={['nav-link', 'm-menu__item', 'dropdown-toggle', this.state.menuOpen ? 'active' : ''].join(" ")} aria-haspopup="true">دسته بندی ها</a>
                                    <div className="category-list-menu have-dropdown-menu" style={{ display: this.state.menuOpen ? 'block' : 'none' }}>
                                        <ul className="list-links">
                                            {catItems.map(catItem =>
                                                <li key={catItem.id}>
                                                    <Link to={`/merchants/${catItem.id}`}
                                                        onMouseOver={this.showCatInfo.bind(this, catItem)}
                                                        className="menu-cat-link">{catItem.name}</Link>
                                                </li>)}
                                        </ul>
                                    </div>
                                </NavItem>

                                <NavItem>
                                    <NavLink className="nav-link m-menu__item" to="/about">درباره ما</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className="nav-link m-menu__item" to="/contact-us">تماس با ما</NavLink>
                                </NavItem>

                                <NavItem className="d-lg-none">
                                    {isAuthenticated ? <UserProfile /> :
                                        <div style={{ padding: 0, margin: 0 }}>
                                            <NavLink className="nav-link1 m-menu__item1 login-menu" to="/login">ورود</NavLink>
                                            <NavLink className="nav-link m-menu__item" to="/register">ثبت نام</NavLink>
                                        </div>
                                    }
                                </NavItem>
                            </NavbarNav>
                        </div>
                    </Collapse>

                    <div className="d-none d-lg-block">
                        <div className="d-flex flex-row top-link ">
                            <div className="p-2">
                                {isAuthenticated ? <UserProfile /> :
                                    <div style={{ padding: 0, margin: 0 }}>
                                        <Link to="/login" title="ورود کاربر" className="btn login-reg">ورود/ثبت نام</Link>
                                    </div>
                                }
                            </div>
                            <div className="separator ">|</div>
                            <div className="p-2 pl-0 lang-wapper">
                                <Link to="https://google.com" title="دریافت اپلیکیشن" className="btn get-app">دریافت اپلیکیشن</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Navbar>
        );
    }
}

Header.propTypes = {
    isAuthenticated: PropTypes.bool
};
const mapStateToProps = (state) => {
    return {
        categories: state.categories,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setCategories: categories => {
            dispatch(setCategories(categories))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));




// WEBPACK FOOTER //
// ./src/components/header/Header.js